"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function SnippetsTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'snippets',
        theme: 'twotone',
        nameWithTheme: 'snippets-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M450 510V336H232v552h432V550H490c-22.1 0-40-17.9-40-40z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z',
                    fill: primaryColor
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'snippets-twotone';
var SnippetsTwoTone = temp;
exports.default = SnippetsTwoTone;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/lib/twotone/SnippetsTwoTone.js
// module id = 1017
// module chunks = 0